import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { UserComponent } from '@sbd-account-portal/app/layout/common/user/user.component';
import { SharedModule } from '@sbd-account-portal/app/shared/shared.module';
import { RouterLink } from '@angular/router';
import { LongListModule } from '@sbd-doug-frontend/shared/lib/ui/longlist/longlist.module';
import { PermissionsModule } from '@sbd-account-portal/app/shared/permissions/permissions.module';

@NgModule({
    declarations: [
        UserComponent
    ],
  imports: [
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    SharedModule,
    RouterLink,
    LongListModule,
    PermissionsModule,
  ],
    exports     : [
        UserComponent
    ]
})
export class UserModule
{
}
